// import './styles.scss'
import JoinForm from './JoinForm'

export default JoinForm
